export default {
	entgratart: {
		notEntgraten: "Nicht entgraten",
		manually: "Manuell",
		oneSided: "Einseitig (Unterseite)",
		trowalisieren: "Trowalisieren",
		bothSides: "Beidseitig",
		undefinedState: "Undefiniert",
		notAvailable: "Nicht verfügbar",
	},
	priceModel: {
		standard: "Schnell",
		slow: "Preiswert",
		express: "Express",
	},
	zincCoating: {
		none: "Nein",
		hotDip: "Feuerverzinkt",
		galvanize: "Galvanisch Verzinkt",
		both: "Beide",
	},
	complainType: {
		outOfTolerance: "Masse ausserhalb der Toleranz",
		wrongBending: "Abkantung fehlerhaft",
		cutQualityLow: "Schnittqualität nicht zufriedenstellend",
		scratches: "Oberfläche übermässig zerkratzt",
		missingCuts: "Fehlende Ausschnitte",
		wrongGrainDirection: "Falsche Schliffrichtung",
		transportDamage: "Transportschaden",
		missing: "Teile fehlen in Lieferung",
		powderCoating: "Pulverbeschichtung fehlerhaft",
		weldline: "Schweißnaht fehlerhaft",
		feature: "Gewinde, Senkungen oder Durchzüge fehlerhaft",
		other: "Andere Beanstandung",
		zincCoating: "Verzinkung fehlerhaft",
		wrongOrMissingPressJoin: "Einpressung fehlt oder entspricht nicht der Bestellung",
	},
	complaintExpectationType: {
		ersatzlieferung: "Ersatzlieferung",
		other: "Andere Erwartung...",
	},
};
